(() => {
  const bar = document.querySelector('.t13-sticky');
  if (!bar) return;
  const main = document.getElementById(bar.dataset.target);
  if (!main) return;
  const go = bar.querySelector('button');
  const price = bar.querySelector('.t13-sticky__price');
  const src = document.querySelector('#price-' + bar.dataset.section + ' .price-item--last');
  const show = (on) => {
    bar.classList.toggle('is-visible', on);
    bar.setAttribute('aria-hidden', String(!on));
    bar.toggleAttribute('inert', !on);
    if (!on) return;
    go.disabled = main.disabled;
    const label = main.querySelector('span');
    if (label && label.textContent.trim()) go.textContent = label.textContent.trim();
    const t = src && src.textContent.trim();
    if (t && /[1-9]/.test(t)) price.textContent = t;
  };
  show(false);
  document.body.classList.add('t13-has-sticky');
  new IntersectionObserver(([e]) => show(!e.isIntersecting && e.boundingClientRect.top < 0)).observe(main);
  go.addEventListener('click', () => main.click());
})();
